"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconSmartEnergySolutions = function IconSmartEnergySolutions(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M38.88 10.161a10.19 10.19 0 0 0-8.692-8.656l-.136.99.27.042a9.19 9.19 0 0 1 7.601 8.02l.994-.114zm-9.023-6.247a7.73 7.73 0 0 1 6.607 6.534l.033.256-.994.112a6.73 6.73 0 0 0-5.527-5.871l-.253-.04zm4.127 6.798a5.25 5.25 0 0 0-4.466-4.337l-.136.99.203.033a4.25 4.25 0 0 1 3.439 3.663l.992-.122zM26 8.97H14a5 5 0 0 0-5 5v24a5 5 0 0 0 5 5h12a5 5 0 0 0 5-5v-24a5 5 0 0 0-5-5m-12 2h12a3 3 0 0 1 3 3v21H11v-21a3 3 0 0 1 3-3m-3 25v2a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-2zm11-22v1h-3v-1zm-.61 4.98-3.44 6.89h1.72V31l3.44-6.89h-1.72zm-.13 19.57a.85.85 0 1 1-1.7 0 .85.85 0 0 1 1.7 0",
    clipRule: "evenodd"
  })));
};

export { IconSmartEnergySolutions, IconSmartEnergySolutions as default };
